import styled from 'styled-components';

type Props = {
  string: string;
};

const StringBoxSP: React.FC<Props> = ({ string }: Props) => {
  return <StyleDiv>{string}</StyleDiv>;
};

const StyleDiv = styled.div`
  width: 48%;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 5px;
  font-size: 16px;
  text-align: center;
  font-weight: bold;
`;

export default StringBoxSP;
